module.exports = __webpack_public_path__ + "img/3-3.892987e5.jpg";